import { HOUR_IN_MILLISECONDS } from 'config';
import {
  ProjectDto,
  useProjectQuery
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { QAQCTablePageParams } from './constants';

export type QAQCTablePageQueries = [
  UseQueryResult<ProjectDto>,
];

const useQAQCTablePageQueries = (params: QAQCTablePageParams): QAQCTablePageQueries => {
  const projectQuery = useProjectQuery(params.projectId, {
    staleTime: HOUR_IN_MILLISECONDS,
  });

  return [projectQuery];
};

export default useQAQCTablePageQueries;
